















import { Component, Prop, Vue } from 'vue-property-decorator'
@Component({})
export default class VtHorizontalListItem extends Vue{
  @Prop({default:'div'}) tag!:string

  @Prop({default:false,type:Boolean}) yScroll!:boolean
  get cssClass_(){
    return {
      'vt-horizontal-list-item--y-scroll':this.yScroll,
    }
  }
  onScroll_(ev:UIEvent){
    const scrollTop = this.$el.scrollTop
    this.$emit('update:scrollTop',scrollTop)
  }
}
